module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-richtext-28474238.svg";